import { IconButton, Stack, Typography } from "@mui/material";
import { CLOSE } from "../assets/icons";
import theme from "../theme/theme";
import SvgContainer from "./SvgContainer";

interface Props {
  title: string;
  onClose(): void;
  style?: React.CSSProperties;
}

function FormModalTitle({ title, style, onClose }: Props) {
  return (
    <Stack
      direction={"row"}
      alignItems="center"
      justifyContent="space-between"
      mb={3}
      sx={{...style}}
    >
      <Typography></Typography>
      <Typography fontSize={25} fontWeight={550}>
        {title}
      </Typography>
      <IconButton onClick={onClose} sx={{width: 32, height: 32}}>
        <SvgContainer svg={CLOSE} color={theme.colors.dimgray} width={30} />
      </IconButton>
    </Stack>
  );
}

export default FormModalTitle;
